import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';
import { Colors } from '../../../layout/theme-next';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    root: {
      overflow: 'auto',
      margin: theme.spacing(1),
    },
    submitButton: {
      '&:hover': {
        backgroundColor: Colors.darkBluish,
      },
    },
  }),
);
